import { render } from "./TabList1.vue?vue&type=template&id=ccce83ce&scoped=true"
import script from "./TabList1.vue?vue&type=script&lang=js"
export * from "./TabList1.vue?vue&type=script&lang=js"

import "./TabList1.vue?vue&type=style&index=0&id=ccce83ce&lang=scss&scoped=true"

import exportComponent from "/data/devops/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccce83ce"]])

export default __exports__